import { render, staticRenderFns } from "./CheckboxOption.vue?vue&type=template&id=73f20f9b&"
import script from "./CheckboxOption.vue?vue&type=script&lang=js&"
export * from "./CheckboxOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports